import { Card } from '@mui/material';
import { useState } from 'react';
import { GeneralTable } from 'src/components/general';
import { APP_SECTION_LIST_MODAL_TABLE_HEAD } from 'src/constants/tableHeads';
import { useAppSectionList } from 'src/hooks/dashboard/useAppSectionList';
import { AppSectionTableToolbar } from 'src/sections/@dashboard/app-section';
import useTable from '../../../hooks/useTable';
import AppSectionListModalTableRow from './AppSectionListModalTableRow';

// ----------------------------------------------------------------------

export default function AppSectionListModal({ selectAppSectionHandler, projectId }) {
  const useTableOptions = useTable();
  const { page, setPage, selected, setSelected, order, orderBy } = useTableOptions;

  const [selectedRow, setSelectedRow] = useState();

  const {
    tableData,
    isLoading,
    deleteLoading,
    handleDeleteRow,
    handleDeleteRows,
    handleEditRow,
    filterName,
    handleFilterName,
    openConfirmDelete,
    setOpenConfirmDelete,
  } = useAppSectionList({ page, setPage, projectId, selected, setSelected, order, orderBy });

  return (
    <Card>
      <AppSectionTableToolbar filterName={filterName} onFilterName={handleFilterName} />

      <GeneralTable
        tableContainerSX={{ position: 'relative' }}
        rowID="ApplicationSectionID"
        tableData={tableData}
        headLabel={APP_SECTION_LIST_MODAL_TABLE_HEAD}
        isLoading={isLoading}
        isDeleteLoading={deleteLoading}
        onEditRow={handleEditRow}
        onDeleteRow={handleDeleteRow}
        onDeleteRows={handleDeleteRows}
        CustomTableRow={AppSectionListModalTableRow}
        setFilterItems={null}
        CustomTableToolbar={null}
        openConfirmDelete={openConfirmDelete}
        setOpenConfirmDelete={setOpenConfirmDelete}
        useTableOptions={useTableOptions}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        selectAppSectionHandler={selectAppSectionHandler}
      />
    </Card>
  );
}
